"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = IntegerCounterInput;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _form = require("@sharingapples/form");

var _reactstrap = require("reactstrap");

require("./integerCounterInput.scss");

IntegerCounterInput.defaultProps = {
  min: 1,
  step: 1,
  max: 25,
  label: '',
  disabled: false
};

function IntegerCounterInput(props) {
  var max = props.max,
      min = props.min,
      step = props.step,
      name = props.name,
      label = props.label,
      disabled = props.disabled,
      getInputText = props.getInputText;

  var _useFormInput = (0, _form.useFormInput)(name),
      _useFormInput2 = (0, _slicedToArray2["default"])(_useFormInput, 2),
      value = _useFormInput2[0],
      onChange = _useFormInput2[1];

  var increment = _react["default"].useCallback(function () {
    if (value < max) return onChange(Number(value) + step);
  }, [value, step, max, onChange]);

  var decrement = _react["default"].useCallback(function () {
    if (value > min) return onChange(Number(value) - step);
  }, [value, step, min, onChange]);

  var getInputTextSingularOrPlural = _react["default"].useCallback(function () {
    if (typeof getInputText === 'function') return getInputText(value);
    return value > 1 ? 'Trekkers' : 'Trekker';
  }, [value, getInputText]);

  return _react["default"].createElement("div", {
    className: "CounterBox",
    disabled: disabled
  }, label && _react["default"].createElement(_reactstrap.Label, null, label), _react["default"].createElement(_reactstrap.InputGroup, null, _react["default"].createElement(Icon, {
    action: function action() {
      if (!disabled) decrement();
    },
    addonType: "prepend",
    iconName: "minus",
    ariaLabel: "decrement"
  }), _react["default"].createElement(_reactstrap.Input, {
    value: "".concat(value, " ").concat(getInputTextSingularOrPlural(value)),
    type: "text",
    "aria-label": label || props['aria-label'],
    readOnly: "readyonly",
    min: "1"
  }), _react["default"].createElement(Icon, {
    action: function action() {
      if (!disabled) increment();
    },
    addonType: "append",
    iconName: "plus",
    ariaLabel: "increment"
  })));
}

var Icon = function Icon(props) {
  var action = props.action,
      addonType = props.addonType,
      iconName = props.iconName,
      ariaLabel = props.ariaLabel;
  return _react["default"].createElement(_reactstrap.InputGroupAddon, {
    onClick: action,
    onKeyPress: action,
    addonType: addonType,
    tabIndex: "0"
  }, _react["default"].createElement("span", {
    className: "input-group-text"
  }, _react["default"].createElement("i", {
    className: "icon icon-hg-".concat(iconName),
    "aria-label": ariaLabel
  })));
};